// extracted by mini-css-extract-plugin
export var intro = "header-module--intro--2g3hr";
export var introPhoto = "header-module--introPhoto--1nC0y";
export var introTextStack = "header-module--introTextStack--3s_j4";
export var emoji = "header-module--emoji--3MtDr";
export var waveAnimation = "header-module--wave-animation--11st3";
export var introText = "header-module--introText--3jv5y";